import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { getImageUrl, createFallbackImage } from '../utils/imageUtils';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const [imageLoaded, setImageLoaded] = useState(false);
  // Formatar preço em reais
  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  };

  // Lógica de Preço
  const originalPrice = product.price !== null && product.price !== undefined ? parseFloat(product.price) : null;
  const salePriceValue = product.salePrice !== null && product.salePrice !== undefined ? parseFloat(product.salePrice) : null;

  let showDiscount = false;
  if (typeof salePriceValue === 'number' && !isNaN(salePriceValue) &&
      typeof originalPrice === 'number' && !isNaN(originalPrice) &&
      salePriceValue > 0 && // Preço promocional deve ser maior que 0
      salePriceValue < originalPrice) {
    showDiscount = true;
  }

  // Função para garantir que o link do produto seja válido
  const getProductLink = () => {
    if (!product || !product.code) return '/';
    return `/produto/${encodeURIComponent(product.code)}`;
  };

  return (
    <div className="product-card">
      <Link to={{ pathname: getProductLink(), search: window.location.search }} className="product-link" onClick={(e) => {
        // Verificar se o produto tem código antes de navegar
        if (!product.code) {
          e.preventDefault();
          console.error('Produto sem código:', product);
          return;
        }
      }}>
        <div className="product-image-container">
          {product.code ? (
            <>
              {/* Div de placeholder que será mostrado enquanto a imagem carrega */}
              <div className="product-image-placeholder" style={{ display: imageLoaded ? 'none' : 'flex' }}>
                <span className="loading-placeholder"></span>
              </div>
              <img 
                src={getImageUrl(`/imagens/${product.code}.png`, 300)} 
                alt={product.name} 
                className={`product-image ${imageLoaded ? 'loaded' : ''}`}
                onLoad={() => setImageLoaded(true)}
                onError={(e) => {
                  e.target.onerror = null;
                  // Se a imagem PNG não for encontrada, usar imagem de fallback
                  e.target.src = createFallbackImage(product.name, 300, 300);
                  setImageLoaded(true);
                }}
                loading="lazy"
                width="300"
                height="300"
                decoding="async"
                fetchpriority="high"
              />
            </>
          ) : (
            <div className="product-image-placeholder">
              <span>Sem imagem</span>
            </div>
          )}
          
          {showDiscount && (
            <div className="discount-badge">
              {Math.round(((originalPrice - salePriceValue) / originalPrice) * 100)}% OFF
            </div>
          )}
        </div>
        
        <div className="product-info">
          <h3 className="product-name">{product.name}</h3>
          
          <div className="product-category">{product.category}</div>
          
          <div className="product-price-container">
            {showDiscount ? (
              <>
                <span className="product-original-price">{formatPrice(originalPrice)}</span>
                <span className="product-sale-price">{formatPrice(salePriceValue)}</span>
              </>
            ) : (
              <span className="product-price">{formatPrice(originalPrice)}</span>
            )}
          </div>
          
          <div className={`product-stock ${product.stock > 0 ? 'in-stock' : 'out-of-stock'}`}>
            {product.stock > 0 ? `${product.stock} em estoque` : 'Fora de estoque'}
          </div>
          
          {product.stock > 0 && (
            <button 
              className="product-card-add-to-cart"
              onClick={(e) => {
                e.preventDefault(); // Evitar navegação para a página do produto
                e.stopPropagation();
                addToCart(product, 1);
              }}
            >
              <i className="fas fa-cart-plus"></i>
              Adicionar
            </button>
          )}
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
